import React, { useState } from 'react'
import { randomInt } from './constants'
//import MongoContext from './MongoContext'
import { mongodb, client, useAuth } from './Auth//use-auth'
import { useHistory, useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
// TODO: staatus:puhkus,haige
const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative'
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    }
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3)
  }
}))

export default function InsertGroup (props) {
  const classes = useStyles()
  const { auth, user } = useAuth()
  const { choice } = useParams()
  const history = useHistory()
  //const { prms } = props.location.query
  const [value, setValue] = useState({
    id: '',
    title: '',
    rightTitle: '',
    StackItems: false,
    bgColor: '#b4e8f7',
    email: '',
    phone: '',
    hidden: false
  })
  React.useEffect(() => {
    if (user) {
      if (choice === 'change') {
        setValue(prevState => ({ ...prevState, id: props.location.query.id }))
        setValue(prevState => ({
          ...prevState,
          title: props.location.query.title
        }))
        setValue(prevState => ({
          ...prevState,
          email: props.location.query.email
        }))
        setValue(prevState => ({
          ...prevState,
          phone: props.location.query.phone
        }))

        String(props.location.query.hidden) === 'true'
          ? setValue(prevState => ({ ...prevState, hidden: true }))
          : setValue(prevState => ({ ...prevState, hidden: false }))
      }
    } else {
      console.log('ei toimi', auth)
    }
  }, [])

  const db = mongodb.db('silmandDB')

  const handleChange = data => {
    console.log('event', data)
    console.log('onchangedata', Object.keys(data)[0])
    switch (Object.keys(data)[0]) {
      case 'id':
        setValue(prevState => ({ ...prevState, id: data.id }))
        break
      case 'title':
        setValue(prevState => ({ ...prevState, title: data.title }))
        break
      case 'bgColor':
        setValue(prevState => ({ ...prevState, bgColor: data.bgColor }))
        break
      case 'email':
        setValue(prevState => ({ ...prevState, email: data.email }))
        break
      case 'phone':
        setValue(prevState => ({ ...prevState, phone: data.phone }))
        break
      case 'hidden':
        String(data.hidden) === 'true'
          ? setValue(prevState => ({ ...prevState, hidden: false }))
          : setValue(prevState => ({ ...prevState, hidden: true }))
        break
      default:
        console.log('No entries from change field')
    }
    console.log('hidden peale muutust', value.hidden)

    // if (data.title) setValue(prevState => ({ ...prevState, title: data.title }))
    // if (data.bgColor)
    //   setValue(prevState => ({ ...prevState, bgColor: data.bgColor }))
  }
  const addGroup = async event => {
    event.preventDefault()
    //console.log('addevent', value, hiddenGroup)

    try {
      await db.collection('groups').insertOne({
        _id: parseInt(randomInt(0, 9)),
        owner_id: client.auth.user.id,
        title: value.title,
        rightTitle: value.rightTitle,
        StackItems: true,
        bgColor: '#b4e8f7', //"#c7e4fc"
        email: value.email,
        phone: value.phone,
        hidden: value.hidden
      })
    } catch (e) {
      console.log('item find viga', e)
    } finally {
      history.push('/mb')
    }
  }
  const changeGroup = async event => {
    event.preventDefault()
    //console.log('addevent', value, hiddenGroup)

    try {
      await db.collection('groups').updateOne(
        { _id: parseInt(value.id) },
        {
          $set: {
            title: value.title,
            rightTitle: value.rightTitle,
            StackItems: true,
            bgColor: value.bgColor,
            email: value.email,
            phone: value.phone,
            hidden: value.hidden
          }
        }
      )
    } catch (e) {
      console.log('item find viga', e)
    } finally {
      history.go(-1)
    }
  }
  const handleBack = e => {
    e.preventDefault()
    //history.push('/mb')
    history.go(-1)
  }
  return (
    <React.Fragment>
      <CssBaseline />
      <AppBar position='absolute' color='default' className={classes.appBar}>
        <Toolbar></Toolbar>
      </AppBar>
      <main className={classes.layout}>
        <Paper className={classes.paper}>
          <React.Fragment>
            <React.Fragment>
              <Grid container spacing={3}>
                {choice === 'change' && (
                  <Grid item xs={4} sm={2}>
                    <TextField
                      variant='outlined'
                      id='id'
                      name='id'
                      label=' ID '
                      value={value.id}
                      InputProps={{
                        readOnly: true
                      }}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant='outlined'
                    required
                    id='title'
                    name='title'
                    label='Name'
                    value={value.title}
                    onChange={event =>
                      handleChange({ title: event.target.value })
                    }
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    variant='outlined'
                    id='email'
                    name='email'
                    label='E-mail'
                    value={value.email}
                    onChange={event =>
                      handleChange({ email: event.target.value })
                    }
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant='outlined'
                    id='phone'
                    name='phone'
                    label='Telefon'
                    value={value.phone}
                    onChange={event =>
                      handleChange({ phone: event.target.value })
                    }
                    fullWidth
                  />
                </Grid>

                <Grid item xs={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        variant='outlined'
                        color='secondary'
                        name='hidden'
                        checked={value.hidden}
                        value={value.hidden}
                        onChange={event =>
                          handleChange({ hidden: event.target.value })
                        }
                      />
                    }
                    label='Peidetud'
                  />
                </Grid>
              </Grid>
            </React.Fragment>
            <React.Fragment>
              <div className={classes.buttons}>
                <Button onClick={handleBack} className={classes.button}>
                  Tagasi
                </Button>
                {choice === 'insert' && (
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={addGroup}
                    className={classes.button}
                  >
                    Lisa
                  </Button>
                )}
                {choice === 'change' && (
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={changeGroup}
                    className={classes.button}
                  >
                    Muuda
                  </Button>
                )}
              </div>
            </React.Fragment>
          </React.Fragment>
        </Paper>
      </main>
    </React.Fragment>
  )
}
// <Grid item xs={12} sm={6}>
//   <TextField
//     variant='outlined'
//     id='bgColor'
//     name='bgColor'
//     label='BackGroung color'
//     value={value.bgColor}
//     onChange={event =>
//       handleChange({ bgColor: event.target.value })
//     }
//     fullWidth
//     autoComplete={value.bgColor}
//   />
// </Grid>
